import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/currency/list.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var getSupportedCurrencies = (_0) => __async(null, [_0], function* ({ lang }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/currencies?lang=${locale}&visible_in=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      includeAuth: false
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSupportedCurrenciesException"
    });
  }
});

export {
  getSupportedCurrencies
};
//# sourceMappingURL=chunk-ZJYF4UXN.mjs.map